import { render, staticRenderFns } from "./ExamAddOrEdit.vue?vue&type=template&id=f07fe5a4&scoped=true&"
import script from "./ExamAddOrEdit.vue?vue&type=script&lang=js&"
export * from "./ExamAddOrEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f07fe5a4",
  null
  
)

export default component.exports